import React, { useState } from "react";
import { Box, Typography, Button, Tooltip } from "@mui/material";
import SubBar from "./SubBar";
import UserTable from "./UserTable";
import PropertiesPage from "./PropertiesPage";
import Permissions from "./Permissions";
import ConfigAiDialog from "./ConfigAiDialog";
import { useRefreshSysProps } from "../../useQuery";
import { PageTitle } from "../../components-new/common";
import { useNotification } from "../../hooks";
import { styled } from "@mui/material";
import { Refresh } from "@mui/icons-material";

import { useLocation } from "react-router-dom";

const StyledButton = styled(Button)`
  padding: 10px 20px;
  border-radius: 8px;
  text-transform: capitalize;
`;

function AdminNewPage() {
  const notify = useNotification();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.tab || 0);
  const [showLlmForm, setShowLlmForm] = useState(false);
  const [adminSubForm, setAdminSubForm] = useState(null);
  const [configAiOpen, setConfigAiOpen] = useState(false);
  const { mutate: updateSysProps, isPending: refreshingSysProps } = useRefreshSysProps({
    onSuccess: () => {
      notify("Refreshed sys props successfully", "success");
    },
    onError: () => {
      notify("Failed to refresh SysProps");
    },
  });

  return (
    <Box p={2}>
      {/* Header */}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <PageTitle title="Admin Control" />
          <Typography variant="body2" sx={{ color: "#666" }}>
            Manage users, properties, and permissions.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 2 }}>
          <Tooltip title={"Refresh Sys Props"} disabled={refreshingSysProps}>
            <StyledButton
              disabled={refreshingSysProps}
              variant="contained"
              color="warning"
              onClick={() => updateSysProps()}
              endIcon={<Refresh />}
              sx={{
                backgroundColor: "#ff5336",
                boxShadow: "0px 16px 30.6px 0px rgba(255, 83, 54, 0.27)",
                padding: "10px 20px",
              }}
            >
              {refreshingSysProps ? "Refreshing.." : "Refresh Sys Props"}
            </StyledButton>
          </Tooltip>

          {activeTab === 1 && adminSubForm === "LLMSetup" && (
            <Box sx={{ display: "flex", flexDirection: "row", gap: 1, mt: 2 }}>
              {!showLlmForm && (
                <StyledButton
                  variant="contained"
                  color="warning"
                  onClick={() => setShowLlmForm(true)}
                  sx={{
                    backgroundColor: "#ff5336",
                    boxShadow: "0px 16px 30.6px 0px rgba(255, 83, 54, 0.27)",
                    padding: "10px 20px",
                  }}
                >
                  Add LLM
                </StyledButton>
              )}

              <StyledButton
                variant="contained"
                color="warning"
                onClick={() => setConfigAiOpen(true)}
                sx={{
                  backgroundColor: "#ff5336",
                  boxShadow: "0px 16px 30.6px 0px rgba(255, 83, 54, 0.27)",
                  padding: "10px 20px",
                }}
              >
                Config AI
              </StyledButton>
            </Box>
          )}
        </Box>
      </Box>

      {/* SubBar */}
      <Box mt={2}>
        <SubBar activeTab={activeTab} setActiveTab={setActiveTab} />
      </Box>

      {/* Content Area */}
      <Box mt={3}>
        {activeTab === 0 && <UserTable />}
        {activeTab === 1 && (
          <PropertiesPage
            showLlmForm={showLlmForm}
            setShowLlmForm={setShowLlmForm}
            onSubFormChange={setAdminSubForm}
          />
        )}
        {activeTab === 2 && <Permissions />}
      </Box>
      <ConfigAiDialog open={configAiOpen} onClose={() => setConfigAiOpen(false)} />
    </Box>
  );
}

export default AdminNewPage;
